import React, { Component } from 'react'
import { FiChevronUp, FiMapPin, FiDownload } from "react-icons/fi";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import Header from "../component/header/Header";

class GoogleMap extends Component {
    render() {
        return (
            <>
                <PageHelmet pageTitle='แผนที่พิพิธภัณฑ์สิงห์ท่า' />

                {/* Start Header Area  */}
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />
                {/* End Header Area  */}
                

                {/* Start Page Wrapper  */}
                <main className="page-wrapper">

                    {/* Hero Section */}
                    <div className="hero-section" style={{
                        background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/images/singha/floor1/IMG_7829.webp")',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        minHeight: '50vh',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative'
                    }}>
                        <div className="container">
                            <div className="row justify-content-center text-center">
                                <div className="col-lg-8">
                                    <h1 className="hero-title" style={{
                                        color: 'white',
                                        fontSize: '3.5rem',
                                        fontWeight: 'bold',
                                        marginBottom: '1.5rem',
                                        textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                                    }}>
                                        แผนที่พิพิธภัณฑ์สิงห์ท่า
                                    </h1>
                                    <p className="hero-subtitle" style={{
                                        color: 'white',
                                        fontSize: '1.3rem',
                                        opacity: 0.9,
                                        marginBottom: '2rem',
                                        textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
                                        lineHeight: '1.6'
                                    }}>
                                        แผนที่พิพิธภัณฑ์สิงห์ท่าและสถานที่ใกล้เคียง<br />
                                        สำหรับการเดินทางและนำทาง
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Navigation to Nearby Places */}
                    <div className="navigation-section ptb--80" style={{ backgroundColor: '#f8f9fa' }}>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 text-center">
                                    <div className="navigation-card" style={{
                                        backgroundColor: 'white',
                                        borderRadius: '20px',
                                        padding: '3rem 2rem',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)'
                                    }}>
                                        <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>🗺️</div>
                                        <h3 style={{
                                            fontSize: '2rem',
                                            fontWeight: 'bold',
                                            color: '#242424',
                                            marginBottom: '1rem'
                                        }}>
                                            แผนที่และสถานที่ท่องเที่ยว
                                        </h3>
                                        <p style={{
                                            color: '#666',
                                            fontSize: '1.2rem',
                                            marginBottom: '2rem',
                                            lineHeight: '1.6'
                                        }}>
                                            ดูแผนที่พิพิธภัณฑ์สิงห์ท่าและสำรวจสถานที่ท่องเที่ยวใกล้เคียง<br />
                                            พร้อมลิงก์แผนที่และข้อมูลการเดินทาง
                                        </p>
                                        <a 
                                            href="/nearby-attractions"
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                padding: '1rem 2rem',
                                                backgroundColor: '#28a745',
                                                color: 'white',
                                                textDecoration: 'none',
                                                borderRadius: '50px',
                                                fontWeight: 'bold',
                                                fontSize: '1.2rem',
                                                transition: 'all 0.3s ease',
                                                boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'translateY(-2px)';
                                                e.target.style.boxShadow = '0 6px 20px rgba(40, 167, 69, 0.4)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'translateY(0)';
                                                e.target.style.boxShadow = '0 4px 15px rgba(40, 167, 69, 0.3)';
                                            }}
                                        >
                                            <FiMapPin style={{ marginRight: '0.5rem' }} />
                                            ดูแผนที่และสถานที่ท่องเที่ยว
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </main>
                {/* End Page Wrapper  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
            </>
        )
    }
}

export default GoogleMap;


